<template>
  <div class="profile-avatar-wrapper">
    <v-avatar color="#e0e0e0" size="60" @click="$emit('click')">
      <div class="profile-avatar-initials" v-if="userName !== 'Add New'">
        {{ initialsFromUsername() }}
      </div>
      <v-icon v-else color="#bdbdbd" dense> mdi-plus-thick </v-icon>
    </v-avatar>
    <div class="user-wrapper" @click="$emit('click')">
      <div class="user-profile-container">{{ userName }}</div>
      <div class="user-profile-container" v-if="email">{{ email }}</div>
      <div style="display: flex">
        <div class="user-profile-container" v-if="shareStatus">
          {{ shareStatus }}
        </div>
        <div class="user-profile-container" v-if="shareExpireDate">
          &nbsp;- Exp. {{ shareExpireDate }}
        </div>
      </div>
      <div v-if="userName !== 'Add New'" class="remove-container" @click="$emit('btnClick')">
        Remove
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProfileAvatar',
  props: {
    userName: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    shareStatus: {
      type: String,
      default: ''
    },
    shareExpireDate: {
      type: String,
      default: ''
    }
  },
  methods: {
    initialsFromUsername() {
      const fullName = this.userName.split(' ')
      if (fullName.length > 1) {
        const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0)
        return initials.toUpperCase()
      } else if (fullName[0].length > 1) {
        const initials = fullName[0].substring(0, 2)
        return initials.toUpperCase()
      } else {
        return this.userName.toUpperCase()
      }
    }
  }
}
</script>

<style scoped>
.profile-avatar-wrapper {
  margin: 10px;
  display: flex;
  flex-direction: row;
}

.profile-avatar-initials {
  color: #bdbdbd;
  font-weight: 700;
  font-size: 16px;
  font-style: normal;
}

.user-profile-container {
  color: #202124;
  font-size: 13px;
  letter-spacing: 0.3px;
  margin-top: 2px;
}

.user-wrapper {
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 115px;
  cursor: pointer;
}

.remove-container {
  color: #999999;
  cursor: pointer;
  font-size: 13px;
  display: contents;
}
@media only screen and (max-width: 571px) {
  .user-wrapper {
    min-width: 250px;
  }
  .user-profile-container {
    word-break: break-word;
    white-space: inherit;
  }
}
</style>
